<template>
  <div id="client-access-list">
    <b-overlay
      variant="white"
      :show="tableLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card>
        <b-tabs v-model="activeTab">
          <b-tab title="Acceptor Logs">
            <custom-g-table v-if="displayTable" ref="custom-table" :displayLoading="tableLoading" :fields="fields"
              :items="data" :totalRows="totalRows" :limit="limit" :hasDeleteButton="false" :hasUpdateDataButton="true"
              :hasAdvancedFilterButton="true" :hasPerPageSelect="true"
              :advancedFilters="advancedFilters" @changePage="onChangePage" @onSortChange="onSortChange"
              @onColumnFilter="onFilter" @updateData="updateData" @fetchAdvancedFilter="onFilter"
              @limitChanged="onLimitChanged" />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { BCard, BTab, BTabs, BOverlay } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import dropdownService from "@/providers/dropdownService";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import acceptorLogsService from "@/providers/acceptorLogsService";
import AppConstants from "@/appConstants";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    BTab,
    BTabs,
    BOverlay,
    CustomGTable,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filter: {},
      tableLoading: true,
      syncParamsForm: {
        origin: null
      },
      isSyncing: false,
      activeTab: 0,
      dataLoaded: false,
      fields: [
        // { field: "dt_create", label: "Data criação", type: "custom_date", sortable: true },
        { field: "dt_update", label: "Data atualização", type: "custom_date", sortable: true },
        { field: "type", label: "Tipo", sortable: true },
        { field: "cma_user", label: "Usuário Logico", sortable: true },
        { field: "client_email", label: "Cliente Email", sortable: true },
        { field: "corrId", label: "CorrelationID", sortable: true },
        { field: "hasError", label: "Erro", type:"boolean", sortable: true },
        { field: "customer_id", label: "CustomerID", sortable: true },
        { field: "domain", label: "Domain", sortable: true },
        { field: "originCode", label: "OriginCode", sortable: true },
        { field: "token", label: "Token", sortable: true },
        { field: "refresh_token", label: "Refresh Token", sortable: true },
        { field: "message_error", label: "Mensagem de erro (Resposta publisher)", sortable: true },
        { field: "data_error", label: "Dados do Erro (Resposta acceptor)", sortable: true },
        { field: "error_code", label: "Código do Erro", sortable: true },
        { field: "times_with_same_error", label: "Vezes com mesmo erro", sortable: true },
        { field: "url", label: "URL Request Acceptor", sortable: true },
        { field: "appruntime_url", label: "App runtime URL", sortable: true },
        { field: "cma_pwd", label: "PWD", sortable: true },
        { field: "service", label: "Serviço", sortable: true },
        { field: "_id", label: "ID", sortable: false },
      ],
      advancedFilters: [
        { field: "type", label: "Tipo", type: 'dropdown', value: '', size: 2, multiple: false, filterDropdownItems: [
          { name: 'Novo token', value: 'newToken' },
          { name: 'Logout', value: 'logout' },
          { name: 'Check', value: 'check' },
          { name: 'Refresh token', value: 'refreshToken' },
        ] },
        { field: "client_email", label: "Cliente Email", type: 'input', value: '', size: 3 },
        { field: "cma_user", label: "Usuário Logico", type: 'input', value: '', size: 3 },
        { field: "corrId", label: "CorrelationID", type: 'input', value: '', size: 3 },
        { field: "domain", label: "Domain", type: 'input', value: '', size: 2 },
        // { field: "originCode", label: "OriginCode", type: 'input', value: '', size: 1 },
        { field: "token", label: "Token", type: 'input', value: '', size: 6 },
        { field: "refresh_token", label: "Refresh token", type: 'input', value: '', size: 6 },
        { field: "message_error", label: "Mensagem de erro", type: 'input', value: '', size: 3 },
        { field: "data_error", label: "Dados do Erro", type: 'input', value: '', size: 3 },
        // { field: "error_code", label: "Refresh token", type: 'input', value: '', size: 3 },
        { field: "dt_create", label: "Data", type: 'dateRange', value: '', size: 2 },
        { field: "hasError", label: "Filtrar por Erro", type: "dropdown", sortable: false, size: 2, filterDropdownItems: [{value: true, name: 'Sim'}, {value: false, name: 'Não'}]},
      ],
      filters: {},
      origins: [],
      device: [],
      browser: [],
      operatingSystem: [],
      countryAccess: [],
      dtRangeAccessStatisticsFilters: "",
      displayOverlay: false
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", "Acceptor Logs");
    this.setInitialTableFilters();
    // this.loadDataFilter();
    // this.transformFilterDropdownItems();
    // this.loadStatisticsData();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }

      // if (this.filters.hasError != undefined) {
      //   if (this.filters.hasError == false) params.append('hasError', this.filters.hasError);
      // }
      // if (this.filters.dt_create) {
      //   params.append('dt_create', this.filters.dt_create);
      // }
      // if (this.filters.origin) {
      //   params.append('origin', this.filters.origin);
      // }

      return params;
    },
  },
  methods: {
    onTabChange() {
    if (this.activeTab === 1 && !this.dataLoaded) {
      this.loadStatisticsData();
      this.dataLoaded = true; 
    }
  },
    onLimitChanged(newLimit) {
      this.limit = newLimit;
      this.loadData();
    },
    exportData() {
      if (!this.searchParams.has("dt_create") || !this.searchParams.get("dt_create")) {
        messagesNotifyHelper.errorNotify("Acessos de clientes", "Filtro data é obrigatório.");
        return;
      }
      this.tableLoading = true;
      acceptorLogsService
        .reportClientAccessSystem(this.searchParams)
        .then((response) => {
          this.tableLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'acessos_clientes.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => {
          this.tableLoading = false;
          console.log(err);
        });
    },
    setInitialTableFilters() {
      // Object.keys(this.urlQuery).forEach(item => {
      //   this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      // });
      Object.keys(this.urlQuery).forEach(item => {
        this.advancedFilters[this.advancedFilters.findIndex(val => val.field == item)].value = this.urlQuery[item];
      });
      this.loadData();
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      console.log('onFilter', data);

      let filteredData = { ...data };

      if (data.device !== undefined) {
        filteredData.isDesktop = data.device;
        delete filteredData.device;
      }
      if (data.hasError != undefined) {
        filteredData.hasError = data.hasError;
        console.log('[Filter][hasError]',filteredData.hasError);
      }

      setRouteQuery(filteredData, this.$route.query);
      this.filters = filteredData;
      this.loadData();
    },
    loadDataFilter() {
      const params = new URLSearchParams();
      params.append('code', AppConstants.ORIGINS.SAFRAS_PLATFORM);
      dropdownService.getAllOrigin(params)
        .then(res => {
          // const origins = res.map(item => {
          //   return { value: item.id, text: item.name };
          // });
          // this.fields[this.fields.findIndex(item => item.field=='origin')].filterOptions.filterDropdownItems = origins;
          this.advancedFilters[this.advancedFilters.findIndex(item => item.field == 'origin')].filterDropdownItems = res;
          this.syncParamsForm.origin = res.find(item => item.code == 250);
          this.setInitialTableFilters();
        })
        .catch(err => console.log(err));
    },
    loadData() {
      this.data = [];
      this.tableLoading = true;
      // this.displayTable = false;
      onlyLatestRequest(this, 'loadData', acceptorLogsService.findAll(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.data = res.data;
          this.totalRows = res.totalRows;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
    clearFilters() {
      this.fields.forEach(field => {
        if (field.filterOptions && field.filterOptions.filterValue !== undefined) {
          field.filterOptions.filterValue = '';
        }
      });
      const query = { ...this.$route.query };
      Object.keys(query).forEach(key => {
        if (!['page', 'limit', 'lang'].includes(key)) {
          delete query[key];
        }
      });
      this.$router.replace({ query });
      this.$forceUpdate();
    },
    updateData() {
      // this.clearFilters();
      this.loadData();
    },
  }
};
</script>